import axios from "axios";

export const apiData = async (method, url, data) => {
  const tokenValue = JSON.parse(localStorage.getItem("user"))?.token || "";

  const options = await getOptionsConfig(method, url, data, tokenValue);

  try {
    const response = await axios.request(options);
    if (response && response.data) {
      const resData = response.data;

      // Handle multiple possible structures safely
      const parsedData =
        resData.result ||                // new structure (OTP, etc.)
        resData.data?.data ||            // old nested data.data.data
        resData.data ||                  // flat data
        [];                              // fallback empty array

      return {
        success: resData.success ?? response.success ?? false,
        statusCode: response.status,
        msg: resData.message || response.message || "Success",
        data: parsedData,
        pagination: resData.totalCount || null,
      };
    }
  } catch (ex) {
    console.error("Request Error:", ex);
    if (ex.response) {
      // Handle known backend errors
      return {
        success: false,
        statusCode: ex.response.status,
        msg: ex.response.data.message || "An error occurred.",
      };
    } else {
      // Handle network or unexpected errors
      return {
        success: false,
        statusCode: 500,
        msg: "An internal error occurred. Please try again later.",
      };
    }
  }
};

async function getOptionsConfig(method, url, data, token) {
  if (method === "get") {
    return {
      method,
      url,
      params: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
  } else if (method === "post") {
    if (url.includes("signIn")) {
      return {
        method,
        url,
        data,
        headers: { "Content-Type": "application/json" },
      };
    } else {
      if (data instanceof FormData) {
        return {
          method,
          url,
          data,
          headers: {
            // "Content-Type": "multipart/form-data",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        };
      } else {
        return {
          method,
          url,
          data,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };
      }
    }
  } else if (method === "delete") {
    return {
      method,
      url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };
  } else {
    // For patch, put, etc:
    if (data instanceof FormData) {
      return {
        method,
        url,
        data,
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      };
    } else {
      return {
        method,
        url,
        params: data,
        data,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
    }
  }
}
